import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeViewItemEventProperties, IGetAmplitudeViewItemEventPropertiesParams} from "./get_amplitude_view_item_event_properties";

export const trackAmplitudeOfferViewItem = (params: IGetAmplitudeViewItemEventPropertiesParams) => {
    trackAmplitudeEvent("view_item", {
        location: params.property ? "property_page" : "investment_page",
        ...getAmplitudeViewItemEventProperties(params)
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeViewItemEventProperties, IGetAmplitudeViewItemEventPropertiesParams} from "./get_amplitude_view_item_event_properties";

export const trackAmplitudeOfferViewItem = (params: IGetAmplitudeViewItemEventPropertiesParams) => {
    trackAmplitudeEvent("view_item", {
        location: params.property ? "property_page" : "investment_page",
        ...getAmplitudeViewItemEventProperties(params)
    });
};
